// Sezon yardımcıları — saf fonksiyonlar (React/ağ bağımlılığı yok).
//
// Kural (proje sahibi kararı 2026-10-03):
//   Teklifin sezonu KAYIT (createdAt) tarihine göre belirlenir ve `offers.season` kolonuna yazılır.
//   Yeni teklif, Ayarlar'daki AKTİF SEZON ile kaydedilir (sezonu proje sahibi değiştirir).
//   Migration 004 ile o güne kadarki tüm teklifler '2025-2026' olarak işaretlendi.
//
// `season` biçimi: 'YYYY-YYYY' (ör. '2026-2027'), ikinci yıl birincinin bir fazlası.
// Kayıtta sezon yoksa (eski sürüm sekmesinden kaydedilen teklif) createdAt'ten türetilir:
// sezon 1 Haziran'da başlar → 05.10.2026 → '2026-2027', 10.02.2026 → '2025-2026'.

export const SEASON_START_MONTH = 6; // Haziran
export const ALL_SEASONS = 'all';    // seçicide "Tüm Sezonlar"
export const SEASON_PATTERN = /^(\d{4})-(\d{4})$/;

export const isValidSeason = (season) => {
  const m = SEASON_PATTERN.exec(String(season ?? '').trim());
  return !!m && Number(m[2]) === Number(m[1]) + 1;
};

export const seasonLabel = (startYear) => `${startYear}-${startYear + 1}`;

// Tarihten sezon: 1 Haziran ve sonrası yeni sezon. Geçersiz tarihte '' döner.
export const seasonFromDate = (value) => {
  // new Date(null) 1970'i verir → boş değerler önce elenir
  if (value === null || value === undefined || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const year = d.getFullYear();
  return seasonLabel(d.getMonth() + 1 >= SEASON_START_MONTH ? year : year - 1);
};

// Teklifin sezonu: kayıtlı değer, yoksa createdAt'ten türetilen değer ('' olabilir).
export const offerSeason = (offer) => {
  const saved = String(offer?.season ?? '').trim();
  if (isValidSeason(saved)) return saved;
  return seasonFromDate(offer?.createdAt);
};

export const offerInSeason = (offer, season) =>
  !season || season === ALL_SEASONS || offerSeason(offer) === season;

// GÖRÜNTÜLEME seçicisi (üstteki kutu): tekliflerde geçen sezonlar + aktif sezon + o an seçili sezon.
// Teklifi olmayan gelecek sezon burada GÖSTERİLMEZ; seçili sezon teklifler henüz yüklenmemişken bile listede kalır
// (yoksa kutu boş görünür ve kullanıcı o sezona geri dönemez).
export const viewSeasonOptions = (offers = [], activeSeason = '', selectedSeason = '') => {
  const set = new Set();
  (offers || []).forEach(o => { const s = offerSeason(o); if (isValidSeason(s)) set.add(s); });
  [activeSeason, selectedSeason].forEach(s => { if (isValidSeason(s)) set.add(s); });
  return [...set].sort((a, b) => Number(b.slice(0, 4)) - Number(a.slice(0, 4)));
};

// AYARLAR kutusu: tekliflerde geçenler + aktif sezon + bir sonraki sezon (yeni sezona geçmek için), yeniden eskiye.
export const seasonOptions = (offers = [], activeSeason = '') => {
  const set = new Set();
  (offers || []).forEach(o => { const s = offerSeason(o); if (isValidSeason(s)) set.add(s); });
  if (isValidSeason(activeSeason)) {
    set.add(activeSeason);
    set.add(seasonLabel(Number(SEASON_PATTERN.exec(activeSeason)[1]) + 1));
  }
  return [...set].sort((a, b) => Number(b.slice(0, 4)) - Number(a.slice(0, 4)));
};
